<div *ngIf="componentReady" class="BatchMove">
  <div class="alert alert-info">
    <p>
      Batch move allows you to move multiple contacts to the same destination
      account and group. Please note this will apply to all selected contacts
    </p>
  </div>
  <div [formGroup]="inputForm">
    <div class="row">
      <div class="col col-6">
        <mat-label>Destination Account:</mat-label>
      </div>
      <div class="col col-6">
        <app-select
          label="Destination Account"
          [items]="items"
          formControlName="accountId"
          (selection)="onAccountSelection($event)"></app-select>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col col-6">
        <mat-label>Destination Group:</mat-label>
      </div>
      <div class="col col-6">
        <app-select
          label="Destination Group"
          [items]="groupItems"
          formControlName="groupId"></app-select>
      </div>
    </div>
  </div>
</div>
